import { DuplicateDebtors } from "us.collection.debtor/constants/Actions";
import { IDuplicateDebtorsActions } from "us.collection.debtor/Interfaces"
import { IAPIAction } from "us.collection/interfaces/API";

const {
  SEARCH_DUPLICATING_DEBTORS,
  SEARCH_DUPLICATING_DEBTORS_SUCCESS,
  SEARCH_DUPLICATING_DEBTORS_FAIL,
  SELECT_DUPLICATE_DEBTORS,
  CHANGE_RETAINING_DEBTOR,
  MERGE_DUPLICATE_DEBTORS,
  MERGE_DUPLICATE_DEBTORS_SUCCESS,
  MERGE_DUPLICATE_DEBTORS_FAIL,
  GET_DUPLICATE_DEBTORS_HISTORY,
  GET_DUPLICATE_DEBTORS_HISTORY_SUCCESS,
  GET_DUPLICATE_DEBTORS_HISTORY_FAIL
} = DuplicateDebtors;

export const duplicateDebtors: Readonly<IAPIAction & IDuplicateDebtorsActions> = {
  debtors: {
    search: (data) => ({
      type: SEARCH_DUPLICATING_DEBTORS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    select: (data) => ({
      type: SELECT_DUPLICATE_DEBTORS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    changeRetaining: (data) => ({
      type: CHANGE_RETAINING_DEBTOR,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: SEARCH_DUPLICATING_DEBTORS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: SEARCH_DUPLICATING_DEBTORS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  mergeDebtors: {
    merge: (data) => ({
      type: MERGE_DUPLICATE_DEBTORS,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: MERGE_DUPLICATE_DEBTORS_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: MERGE_DUPLICATE_DEBTORS_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  },
  debtorHistory: {
    get: (data) => ({
      type: GET_DUPLICATE_DEBTORS_HISTORY,
      payload: {
        data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: GET_DUPLICATE_DEBTORS_HISTORY_SUCCESS,
      payload: {
        data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: GET_DUPLICATE_DEBTORS_HISTORY_FAIL,
      payload: {
        error,
        isLoading: false,
      },
    }),
  }
};
